<template>
  <div class="grid__cell col9-of-12--medium-up fade-in">
    <div class="ta-center pt-lg pb-lg">
      <h1 class="fs-hg directory-tech-title">Gain Trust with Your Prospects</h1>
      <br />
      <p class="fs-xl pt-lg directory-tech-sub-title">
        Showcase the brands that you partner with on your website with your own
        partner directory.
      </p>
    </div>
    <div class="ta-center pt-lg pb-lg">
      <Button
        bType="secondary"
        bMargin="all"
        v-on:button-click="open(previewLink)"
        >Preview Our Directory</Button
      >
      <Button
        bType="secondary"
        bMargin="all"
        v-on:button-click="$router.push('/agency/our-directory/settings')"
        >Brand Our Directory</Button
      >
      <Button
        bType="secondary"
        bMargin="all"
        v-on:button-click="
          $router.push('/agency/our-directory/manage-partners')
        "
        >Manage Partners</Button
      >
    </div>
    <hr />
    <div class="pt-lg pb-lg testimonial-section">
      <p class="quote-content">
        "Partner logos help us establish trust and authority within our market"
        ~ Tim R., Agency CEO
      </p>
    </div>
    <hr />
    <div>
      <h2 class="fw-bold fs-xxl pt-lg pb-lg">FAQ's</h2>

      <div class="mb-sm">
        <p class="fw-bold fs-lg mb-xs">Is this directory free?</p>
        <p class="fs-md">
          Yes. Every agency on the PartnerPage platform gets a free technology
          directory.
        </p>
      </div>

      <div class="mb-sm">
        <p class="fw-bold fs-lg mb-xs">Can I brand my agency directory?</p>
        <p class="fs-md">
          Yes. You can add your own header and footer to match your website, and
          also change the URL to yours.
        </p>
      </div>

      <div class="mb-sm">
        <p class="fw-bold fs-lg mb-xs">
          How long does it take to implement this directory on my website?
        </p>
        <p class="fs-md">
          It shouldn't take your web developer longer than 20 minutes.
        </p>
      </div>
      <div class="mb-sm">
        <p class="fw-bold fs-lg mb-xs">
          How do I add all of my partners to my directory?
        </p>
        <p class="fs-md">
          Go to the "Find Partners" tab and add your partners there.
        </p>
      </div>

      <div class="mb-sm">
        <p class="fw-bold fs-lg mb-xs">Why do I want to display my partners?</p>
        <p class="fs-md">
          Your prospects will view you not only as more credible, but also
          having relevant experience if you have experience with the software
          that they already use.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/DesignSystem/Button';

export default {
  components: {
    Button,
  },
  computed: {
    rootUrl() {
      return process.env.VUE_APP_ROOT_CLIENT;
    },
    directoryUrl() {
      return this.$store.getters['settings'].partnerpageUrl;
    },
    previewLink() {
      if (this.$store.getters['settings'].customDomain) {
        return this.$store.getters['settings'].customDomain;
      }

      return 'http://' + this.directoryUrl + '.' + this.rootUrl;
    },
  },
  methods: {
    open(link) {
      window.open(link, '_blank');
    },
  },
};
</script>
